import { defineMessages } from "react-intl";

export const messages = defineMessages({
  webhookActive: {
    id: "2RYRdr",
    defaultMessage: "Active",
    description: "webhooks active label",
  },
  webhookInactive: {
    id: "GNKG74",
    defaultMessage: "Inactive",
    description: "webhooks inactive label",
  },
});
